import { render } from "./AssignVoucherModal.vue?vue&type=template&id=bbbc4efe&scoped=true"
import script from "./AssignVoucherModal.vue?vue&type=script&lang=js"
export * from "./AssignVoucherModal.vue?vue&type=script&lang=js"

import "./AssignVoucherModal.vue?vue&type=style&index=0&id=bbbc4efe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbc4efe"]])

export default __exports__